import { render, staticRenderFns } from "./DataModalPage.vue?vue&type=template&id=3fc87bc4&"
import script from "./DataModalPage.vue?vue&type=script&lang=ts&"
export * from "./DataModalPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports